<ng-template #modalEmailAddSender let-c="close" let-d="dismiss">
  <wsb-email-add-sender-modal
    class="email-add-sender-modal-content"
    (save)="modalAddEmailSender($event)"
    (cancelEvent)="modalAddEmailSenderDismiss()"
    title="{{ 'mail_campaign_add_user_mail' | translate }}"
    text="{{ 'mail_user_add_description' | translate }}"
  >
  </wsb-email-add-sender-modal>
</ng-template>
<ng-template #modalSuccessNewSender let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="dismissModalSuccessNewSender()"
    primaryButtonText="{{ 'common_close' | translate }}"
    text="{{ 'mail_campaigns_activateuseremail_success' | translate }}"
  >
  </wsb-modal>
</ng-template>
<ng-template #modalDeleteSender let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modaleSeleteEmailSender()"
    (dismiss)="dismissModalDeleteEmailSender()"
    text="{{ 'mail_campaigns_deleteuseremail_confirm' | translate }}"
  >
  </wsb-modal>
</ng-template>
<ng-template #modalSuccessActiveSender let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="dismissModalSuccessActiveSender()"
    primaryButtonText="{{ 'common_close' | translate }}"
    text="{{ 'mail_campaigns_activateuseremail_success' | translate }}"
  >
  </wsb-modal>
</ng-template>
<div class="page">
  <div class="page__container" #page>
    <h1 class="page__title  h2" translate>mail_campaign_setup_title</h1>
    <div class="my-5">
      <form [formGroup]="setupForm">
        <div>
          <h3 class="my-5" translate>mail_campaign_setup_configuration</h3>
          <div class="page__form-wrap">
            <!-- title -->
            <ng-container>
              <div class="form-group row">
                <label class="col-sm-4" translate>mail_campaign_setup_title_input</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    formControlName="title"
                    wsbAppControlValidator
                    [fc]="setupForm.get('title')"
                  />
                  <wsb-validation-error-msg [fc]="setupForm.get('title')"></wsb-validation-error-msg>
                </div>
              </div>
            </ng-container>
            <!-- description -->
            <ng-container>
              <div class="form-group row">
                <label class="col-sm-4" translate>mail_group_description</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    id="description"
                    formControlName="description"
                    wsbAppControlValidator
                    [fc]="setupForm.get('description')"
                  />
                  <wsb-validation-error-msg [fc]="setupForm.get('description')"></wsb-validation-error-msg>
                </div>
              </div>
            </ng-container>
            <!-- language -->
            <ng-container>
              <div class="form-group row" *ngIf="showDropdownLang">
                <label class="col-sm-4" translate>mail_campaign_setup_language_input</label>
                <div class="col-sm-8">
                  <ng-select
                    id="idLanguage"
                    bindValue="id"
                    bindLabel="value"
                    formControlName="idLanguage"
                    [items]="languages"
                    [clearable]="false"
                    class="form-control"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      <span>{{ item.value | translate }}</span>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </ng-container>
            <!-- sender -->
            <ng-container>
              <div class="form-group row">
                <label class="col-sm-4" translate>mail_campaign_setup_sender_input</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    id="sender"
                    formControlName="sender"
                    wsbAppControlValidator
                    [fc]="setupForm.get('sender')"
                  />
                  <wsb-validation-error-msg [fc]="setupForm.get('sender')"></wsb-validation-error-msg>
                </div>
              </div>
            </ng-container>
            <!-- email sender -->
            <ng-container>
              <div class="form-group row">
                <label class="col-sm-4" translate>mail_campaign_setup_senderemail_input</label>
                <div class="col-sm-8">
                  <ng-select
                    id="emailSender"
                    bindValue="emailSender"
                    bindLabel="emailSender"
                    formControlName="emailSender"
                    [items]="listActiveSenderEmail"
                    [clearable]="false"
                    class="form-control"
                  >
                  </ng-select>
                </div>
              </div>
            </ng-container>
            <ng-container>
              <div class="form-group row w-100">
                <!-- <label class="col-sm-4"></label> -->
                <div class="mt-5 mb-2 w-100">
                  <table class="table">
                    <tbody>
                      <tr *ngFor="let email of tableEmaiSenderlList">
                        <td class="text-start">{{ email.emailSender }}</td>
                        <td class="text-center">
                          {{ !email.isActive && !email.waitingActivation ? ('mail_user_notactive' | translate) : '' }}
                        </td>
                        <td class="text-center">
                          {{ !email.isActive && email.waitingActivation ? ('mail_user_activation_sent' | translate) : '' }}
                        </td>
                        <td class="text-center">{{ email.isAcitve ? ('mail_user_activate' | translate) : '' }}</td>
                        <td class="text-center">
                          <wsb-atlas-button
                            *ngIf="!email.isActive && !email.waitingActivation"
                            class="custom-btn-active mb-2"
                            [label]="'mail_campaign_status_active'"
                            [variant]="'secondary'"
                            (click)="btnActiveMail(email.idEmailAddress)"
                          ></wsb-atlas-button>
                        </td>
                        <td class="text-end">
                          <wsb-atlas-button
                            class="mb-2"
                            [variant]="'danger'"
                            [icon]="faTrash"
                            (click)="openModalDeleteEmailSender(email.idEmailAddress)"
                          ></wsb-atlas-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
            <!-- adduseremail_modal  -->
            <ng-container>
              <div class="form-group row">
                <label class="col-sm-4"></label>
                <div class="col-sm-8 custom">
                  <span class="icon" inlineSVG="assets/images/icons/icon-num-plus.svg"></span>
                  <span
                    ><a class="custom-text" (click)="openModalAddEmailSender()" translate>{{
                      'mail_campaigns_adduseremail_modal'
                    }}</a></span
                  >
                </div>
              </div>
            </ng-container>
            <!-- replyTo -->
            <ng-container>
              <div class="form-group row">
                <label class="col-sm-4" translate>mail_campaign_setup_replyto_input</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="replyTo" formControlName="replyTo" />
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </form>
      <div class="page__actions  actions-bar" #actionsBar style="z-index: 1" *ngIf="setupForm">
        <span class="actions-bar__bg"></span>
        <!-- <div class="actions-bar__container" toastContainer></div> -->
        <div class="actions-bar__container  actions-bar__container--actions">
          <div class="d-flex">
            <button
              #submitBtn
              (click)="save()"
              class="btn btn-primary btn-sm"
              [disabled]="setupForm.pristine || setupForm.invalid"
              translate
            >
              common_save
            </button>
            <button #submitBtn (click)="goBack()" class="btn  btn-secondary ms-3 btn-sm" translate>common_back</button>
            <button *ngIf="setupForm.dirty" type="button" class="btn btn-link btn-sm ms-4" (click)="resetForm()" translate>
              common_cancel
            </button>
          </div>
          <div *ngIf="!setupForm.pristine" class="mt-2">
            <small translate>common_unsaved_changes</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
